export { default, type LanguageStore } from './language'
